/*! Bliss · Age gate (vanilla, no deps) — BB-A11Y-V1 */
(function(){
  var KEY = 'bb_age_verified';
  var DAYS = 90;
  var SIBLING_FLAG = 'data-bb-age-inerted';
  var qs = new URLSearchParams(location.search);
  if (qs.get('age_verified') === '1') { setCookie(KEY, '1', DAYS); return; }
  if (getCookie(KEY) === '1') return;

  document.addEventListener('DOMContentLoaded', function(){
    var gate = document.querySelector('[data-bliss-age-gate]');
    if (!gate) return;

    // If the gate is not a direct child of <body>, move it there so the
    // inert/aria-hidden toggle on body children works cleanly.
    if (gate.parentNode !== document.body) {
      document.body.appendChild(gate);
    }

    showGate(gate);

    var yes = gate.querySelector('[data-bliss-age-yes]');
    if (yes) yes.addEventListener('click', function(){
      setCookie(KEY, '1', DAYS);
      dismissGate(gate);
    });
  });

  function showGate(gate){
    gate.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';

    // Mark all body siblings as inert + aria-hidden so AT and keyboard
    // can't escape the modal. Skip the gate itself and skip <script>/<style>
    // tags (no point hiding them).
    var children = document.body.children;
    for (var i = 0; i < children.length; i++) {
      var el = children[i];
      if (el === gate) continue;
      var tag = el.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'LINK') continue;
      // Preserve any pre-existing aria-hidden so we can restore it.
      var prev = el.getAttribute('aria-hidden');
      el.setAttribute(SIBLING_FLAG, prev == null ? '' : prev);
      el.setAttribute('aria-hidden', 'true');
      // `inert` is a standard HTML attribute (Chrome 102+, Safari 15.5+, FF 112+).
      // Older browsers fall back to aria-hidden alone, which is enough for AT.
      try { el.inert = true; } catch (_) { el.setAttribute('inert', ''); }
    }

    // Initial focus on the primary action (confirm).
    var focusables = gate.querySelectorAll('[data-bliss-age-yes], a.bliss-age-no');
    if (focusables.length) focusables[0].focus();

    // Trap focus inside the modal — Tab cycles between Yes and No only.
    gate.addEventListener('keydown', function(e){
      if (e.key === 'Escape') { e.preventDefault(); /* Esc does NOT dismiss per brief §13 */ return; }
      if (e.key !== 'Tab') return;
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  function dismissGate(gate){
    gate.setAttribute('hidden', '');
    document.body.style.overflow = '';

    // Restore aria-hidden + inert on the siblings we touched.
    var marked = document.querySelectorAll('[' + SIBLING_FLAG + ']');
    for (var i = 0; i < marked.length; i++) {
      var el = marked[i];
      var prev = el.getAttribute(SIBLING_FLAG);
      el.removeAttribute(SIBLING_FLAG);
      if (prev) { el.setAttribute('aria-hidden', prev); }
      else { el.removeAttribute('aria-hidden'); }
      try { el.inert = false; } catch (_) { el.removeAttribute('inert'); }
    }

    // Move focus to a sensible page target so the user isn't dropped on body.
    var target = document.querySelector('main a, main button, [role="main"] a, [role="main"] button, header a, header button');
    if (target && typeof target.focus === 'function') {
      target.focus();
    } else {
      // Fallback: make body programmatically focusable just for this move.
      document.body.setAttribute('tabindex', '-1');
      document.body.focus();
      document.body.removeAttribute('tabindex');
    }
  }

  function setCookie(name, value, days) {
    var d = new Date(); d.setTime(d.getTime() + days*24*60*60*1000);
    document.cookie = name + '=' + value + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
  }
  function getCookie(name) {
    var v = ('; ' + document.cookie).split('; ' + name + '=');
    if (v.length === 2) return v.pop().split(';').shift();
    return null;
  }
})();
